webpackJsonp([97509312907296],{

/***/ 1829:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  width: 80vw;\n  height: 70vh;\n  margin: auto;\n  padding: 100px;\n\n  p,\n  a {\n    font-size: 1.6rem;\n    margin-bottom: 10px;\n  }\n  a {\n    font-size: 1.6rem;\n    background: rgba(67, 171, 96, 0.3);\n    border-bottom: 4px solid rgba(67, 171, 96, 0.8);\n    transition: all 0.3s ease;\n  }\n  a:hover {\n    background: rgba(67, 171, 96, 0.8);\n  }\n\n  h1 {\n    margin-bottom: 50px;\n  }\n\n  table {\n    margin: 50px auto;\n    border-collapse: collapse;\n    width: 100%;\n  }\n\n  td,\n  th {\n    font-size: 1.6rem;\n    border: 1px solid #dddddd;\n    text-align: left;\n    padding: 8px;\n  }\n\n  tr:nth-child(even) {\n    background-color: #dddddd;\n  }\n"], ["\n  width: 80vw;\n  height: 70vh;\n  margin: auto;\n  padding: 100px;\n\n  p,\n  a {\n    font-size: 1.6rem;\n    margin-bottom: 10px;\n  }\n  a {\n    font-size: 1.6rem;\n    background: rgba(67, 171, 96, 0.3);\n    border-bottom: 4px solid rgba(67, 171, 96, 0.8);\n    transition: all 0.3s ease;\n  }\n  a:hover {\n    background: rgba(67, 171, 96, 0.8);\n  }\n\n  h1 {\n    margin-bottom: 50px;\n  }\n\n  table {\n    margin: 50px auto;\n    border-collapse: collapse;\n    width: 100%;\n  }\n\n  td,\n  th {\n    font-size: 1.6rem;\n    border: 1px solid #dddddd;\n    text-align: left;\n    padding: 8px;\n  }\n\n  tr:nth-child(even) {\n    background-color: #dddddd;\n  }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RatesPage = function (_Component) {
	  _inherits(RatesPage, _Component);
	
	  function RatesPage() {
	    _classCallCheck(this, RatesPage);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  RatesPage.prototype.render = function render() {
	    return _react2.default.createElement(
	      RatesPageContainer,
	      null,
	      _react2.default.createElement(
	        "h1",
	        null,
	        "AppTree Software Hourly Rate for Services"
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "AppTree Software has a regular hourly rate of $175 per hour and offers significant discounts for pre-paid services."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "For customers pre-paying for services, please use the table below to estimate your rate:"
	      ),
	      _react2.default.createElement(
	        "table",
	        null,
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            null,
	            "Pre-Paid Hours"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "Discount"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "Hourly Rate"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "td",
	            null,
	            "0 to 50 Hours"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "0%"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "$175"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "td",
	            null,
	            "51 to 100 Hours"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "5%"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "$166"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "td",
	            null,
	            "101 to 150 Hours"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "10%"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "$158"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "td",
	            null,
	            "151 to 200 Hours"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "15%"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "$149"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "td",
	            null,
	            "More than 200 Hours"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "20%"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "$140"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        _react2.default.createElement(
	          "a",
	          { href: "mailto:info@apptreesoftware.com" },
	          "Contact AppTree Software"
	        ),
	        " ",
	        "for an estimate for your project. Pre-paid services do not constitute a not-to-exceed agreement."
	      )
	    );
	  };
	
	  return RatesPage;
	}(_react.Component);
	
	exports.default = RatesPage;
	
	
	var RatesPageContainer = _styledComponents2.default.div(_templateObject);
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-rates-jsx-420a17597c4cdb82140a.js